
var stache = require('can/view/stache/stache');
module.exports = stache("<search-component></search-component>");